import { BSMSearchItem } from "./BSMSearchItem";

export default BSMSearchItem;
